"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetConversionIsLoading = exports.makeGetConversion = exports.getCurrencyConverterState = void 0;

var R = _interopRequireWildcard(require("ramda"));

var getCurrencyConverterState = function getCurrencyConverterState(state) {
  return state.modules.currencyConverter;
};

exports.getCurrencyConverterState = getCurrencyConverterState;

var makeGetConversion = function makeGetConversion(id) {
  return R.pipe(getCurrencyConverterState, function (state) {
    var _state$conversions$id;

    return ((_state$conversions$id = state.conversions[id]) === null || _state$conversions$id === void 0 ? void 0 : _state$conversions$id.result) || [];
  });
};

exports.makeGetConversion = makeGetConversion;

var makeGetConversionIsLoading = function makeGetConversionIsLoading(id) {
  return R.pipe(getCurrencyConverterState, function (state) {
    var _state$conversions$id2;

    return ((_state$conversions$id2 = state.conversions[id]) === null || _state$conversions$id2 === void 0 ? void 0 : _state$conversions$id2.isLoading) || false;
  });
};

exports.makeGetConversionIsLoading = makeGetConversionIsLoading;